import { Email } from '@clearkit/icons';
import { CKBannerNext } from 'clearkit';
import { CSSTransition } from 'react-transition-group';

import { AuthBannerProps } from './bannerTypes';

type BannerLinkProps = AuthBannerProps & {
  email?: string | null;
};

export const BannerLink = ({ email, isVisible }: BannerLinkProps) => {
  const EmailText = () =>
    email ? (
      <strong className="font-semibold">{email}</strong>
    ) : (
      <span>this email</span>
    );

  return (
    <CSSTransition
      classNames="ck-fade"
      in={isVisible}
      mountOnEnter
      timeout={300}
      unmountOnExit
    >
      <CKBannerNext className="w-full" variant="info">
        <CKBannerNext.IconStatus>
          <Email />
        </CKBannerNext.IconStatus>
        <CKBannerNext.Header>Sign in link sent</CKBannerNext.Header>
        <CKBannerNext.Body>
          If we have an account for <EmailText />, a secure sign in link has
          been sent. Please check your email.
        </CKBannerNext.Body>
      </CKBannerNext>
    </CSSTransition>
  );
};
